import React from 'react';
import PropTypes from 'prop-types';
import {Text} from "./Text";

class FormButton  extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
		  isButtonDisabled: false,
		  error: false
    	};
	}

	handleSubmit = (e) => {
		e.preventDefault();
		this.setState({isButtonDisabled: true, error: false});
		setTimeout(() => this.setState({ isButtonDisabled: false }), 2000);
		setTimeout(() => {
			if (this.props.hasErrors.length === 0 && Object.keys(this.props.content).length > this.props.numberOfFields) {
				this.props.handleClick();

			} else {
				this.setState({error: true})
			}
		}, 2000)
	};

	render() {
	  // todo add spinner
		const style = {
			backgroundColor: this.props.primaryColor && this.props.success ? `${ this.props.secondaryColor }` : `${ this.props.primaryColor }`,
			color: this.props.textColor && `${this.props.textColor}`
		};
		return (
			<div>
				<button className="btn btn--cta-kiwi btn-basic" disabled={this.state.isButtonDisabled} onClick={this.handleSubmit} style={style}>
					{this.props.label}
				</button>
				{this.state.error.length > 0  && (
					<Text content={"Please complete all fields"}/>
				)}

			</div>

		);
	}
}
export default FormButton;

FormButton.propTypes = {
	label: PropTypes.string,
	handleClick: PropTypes.func,
	color: PropTypes.string,
	textColor: PropTypes.string,
	content: PropTypes.object,
	hasErrors: PropTypes.array,
	numberOfFields: PropTypes.number,
	success: PropTypes.bool
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/elements/FormButton.js